export const DEAL_LABELS = {
  koupe: "Koupě",
  prodej: "Prodej",
  pronajem: "Pronájem",
  jine: "Jiné",
};

export const DEAL_OPTIONS = Object.entries(DEAL_LABELS);
